import { Button } from "@/components/ui/button";
import { SrIcon } from "@/components/ui/SrIcon";

interface InvoicePagerProps {
  page: number;
  pageSize: number;
  total: number;
  onPage: (page: number) => void;
}

/** «Viser 1–50 av 309» med forrige/neste. */
export function InvoicePager({ page, pageSize, total, onPage }: InvoicePagerProps) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (total === 0) return null;
  const first = (page - 1) * pageSize + 1;
  const last = Math.min(page * pageSize, total);
  return (
    <div className="flex flex-wrap justify-between items-center gap-3 text-sm text-muted-foreground">
      <span>Viser {first}–{last} av {total}</span>
      {pages > 1 && (
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={() => onPage(page - 1)} disabled={page <= 1} aria-label="Forrige side">
            <SrIcon name="chevron-left" className="w-4 h-4" />
          </Button>
          <span className="tabular-nums">Side {page} av {pages}</span>
          <Button variant="outline" size="sm" onClick={() => onPage(page + 1)} disabled={page >= pages} aria-label="Neste side">
            <SrIcon name="chevron-right" className="w-4 h-4" />
          </Button>
        </div>
      )}
    </div>
  );
}
